<template>
  <div>
    <!-- <el-row :gutter="5">
      <el-form ref="params" :model="params">
        <el-col :span="4" :xs="12">
          <el-form-item prop="id">
            <el-input
              v-model="params.id"
              maxlength="6"
              placeholder="设备编号"
            />
          </el-form-item>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button type="primary" @click="search">搜索</el-button>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button plain type="success" @click="reset">重置</el-button>
        </el-col>
      </el-form>
    </el-row> -->
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      @click="handlePayAnnualFeeBtnClick"
      >立即缴费</el-button
    >

    <el-table
      v-loading="loadTable"
      :data="records"
      stripe
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column fixed label="设备编号" prop="id" />
      <el-table-column fixed label="设备名称" prop="name" />
      <el-table-column fixed label="小区名称" prop="deviceGroup.groupName" />
      <el-table-column label="设备类型" prop="versions" align="center">
        <template #default="scope">
          {{ versions(scope.row.versions) }}
        </template>
      </el-table-column>
      <el-table-column label="年费价格" align="center">
        <template #default="scope">
          {{ scope.row.deviceAnnualFeeConfig.annualFee }}元
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template #default="scope">
          {{
            scope.row.payAnnualFeeTime - parseInt(new Date().getTime() / 1000) >
            0
              ? "即将过期"
              : "已过期"
          }}
        </template>
      </el-table-column>
      <el-table-column label="过期时间">
        <template #default="scope">
          {{ timeFormat(scope.row.payAnnualFeeTime) }}
        </template>
      </el-table-column>
    </el-table>
    <page :current="current" :size="size" :total="total" />

    <el-dialog
      :fullscreen="dialogFullscreen"
      :visible.sync="choosePayTypeDialog"
      title="选择支付年费的方式"
    >
      <div style="display: flex; justify-content: center">
        <el-radio-group v-model="payType">
          <el-radio :label="1">微信支付</el-radio>
          <el-radio :label="3">余额支付</el-radio>
        </el-radio-group>
      </div>
      <div slot="footer">
        <el-button @click="choosePayTypeDialog = false">取 消</el-button>
        <el-button type="primary" @click="choosePayTypeDialogConfirm"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import getAnnuFeeTimeOutDeviceByPage from "@/api/device/charging-pile-manage/getAnnuFeeTimeOutDeviceByPage";
import payAnnualFeeByWeChat from "@/api/device/charging-pile-manage/payAnnualFeeByWeChat";
import payDeviceAnnualFeeByBalance from "@/api/device/charging-pile-manage/payDeviceAnnualFeeByBalance";
import Page from "@/components/Page";
import dialogMixin from "@/mixin/dialogMixin";
import pageMixin from "@/mixin/pageMixin";
import scanMixin from "@/mixin/scanMixin";
import searchMixin from "@/mixin/searchMixin";
import timeMixin from "@/mixin/timeMixin";
import { Message } from "element-ui";

export default {
  name: "AnnualFeeExpiresDevice",
  components: { Page },
  mixins: [pageMixin, timeMixin, dialogMixin, searchMixin, scanMixin],
  data() {
    return {
      time: [],
      size: 10,
      current: 1,
      loadTable: false,
      records: [],
      selectRows: [],
      choosePayTypeDialog: false,
      params: {
        pageNum: 1,
        size: 10,
        id: null,
      },
      payType: 1,
    };
  },
  methods: {
    reset() {
      this.params.id = null;
      this.current = 1;
      this.time = [];
      this.fetchData();
    },
    fetchData() {
      this.loadTable = true;
      this.params.pageNum = this.current;
      this.params.size = this.size;
      getAnnuFeeTimeOutDeviceByPage(this.params)
        .then((res) => {
          this.records = res.data.records;
          this.total = res.data.total;
        })
        .finally(() => {
          this.loadTable = false;
        });
    },
    handleSelectionChange(rows) {
      this.selectRows = rows;
    },
    // 立即交年费
    handlePayAnnualFeeBtnClick() {
      if (this.selectRows.length <= 0) {
        return this.$message.error("请先选择要缴费的设备！");
      }
      this.choosePayTypeDialog = true;
    },
    choosePayTypeDialogConfirm() {
      if (this.payType == 1) {
        if (this.device === "desktop") {
          return Message({
            message: "请在微信中使用此功能",
            type: "error",
            duration: 3 * 1000,
          });
        }
        // 微信支付
        payAnnualFeeByWeChat({
          memberToken: `bearer${
            localStorage.getItem("wechat_client_token_self") || ""
          }`,
          idList: this.selectRows.map((s) => s.id),
        }).then((res) => {
          //  调起支付
          WeixinJSBridge.invoke(
            "getBrandWCPayRequest",
            {
              // eslint-disable-line
              appId: res.data.appId, //公众号ID，由商户传入
              timeStamp: res.data.timeStamp, //时间戳，自1970年以来的秒数
              nonceStr: res.data.nonceStr, //随机串
              package: res.data.package,
              signType: res.data.signType, //微信签名方式：
              paySign: res.data.paySign, //微信签名
            },
            function (res) {
              if (res.err_msg == "get_brand_wcpay_request:ok") {
                this.choosePayTypeDialog = false;
                this.$message.success("缴费成功~");
                this.fetchData();
              }
            }
          );
        });
      } else {
        // 余额支付
        payDeviceAnnualFeeByBalance({
          idList: this.selectRows.map((s) => s.id),
        }).then(() => {
          this.choosePayTypeDialog = false;
          this.$message.success("缴费成功~");
          this.fetchData();
        });
      }
    },
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    versions() {
      return (versions) => {
        switch (versions) {
          case "1":
            return "8插座";
          case "2":
            return "16插座";
          case "3":
            return "双路ab款";
          case "4":
            return "10路";
          case "5":
            return "4路";
          case "6":
            return "3路";
          case "7":
            return "双路";
          case "8":
            return "新版双路";
          case "9":
            return "新版10路";
        }
      };
    },
  },
};
</script>

<style scoped></style>
